
import { Routes, Route } from 'react-router-dom';
import { TooltipProvider } from '@/components/ui/tooltip';
import { LanguageProvider } from '@/contexts/LanguageContext';
import TreyProfile from './pages/TreyProfile';
import KarenProfile from './pages/KarenProfile';
import JuliaDeRosiProfile from './pages/JuliaDeRosiProfile';
import HeatherEdwardsProfile from './pages/HeatherEdwardsProfile';
import CharlesHardyProfile from './pages/CharlesHardyProfile';

import ChrisProfile from './pages/ChrisProfile';
import CoreyProfile from './pages/CoreyProfile';
import JessProfile from './pages/JessProfile';
import MikeMosherProfile from './pages/MikeMosherProfile';
import ShaanProfile from './pages/ShaanProfile';
import YannisProfile from './pages/YannisProfile';
import MiguelProfile from './pages/MiguelProfile';
import MorganProfile from './pages/MorganProfile';
import PeteProfile from './pages/PeteProfile';
import JimProfile from './pages/JimProfile';
import StevenProfile from './pages/StevenProfile';
import EglantineProfile from './pages/EglantineProfile';
import OzlemProfile from './pages/OzlemProfile';
import Intro from './pages/Intro';
import Index from './pages/Index';
import SolutionBounties from './pages/SolutionBounties';
import KnowYourGib from './pages/KnowYourGib';
import Giblet from './pages/Giblet';
import CurtChannel from './pages/CurtChannel';
import GsaChannel from './pages/GsaChannel';
import ChevronChannel from './pages/ChevronChannel';
import IspaiChannel from './pages/IspaiChannel';
import BechtelChannel from './pages/BechtelChannel';
import DeptEducationChannel from './pages/DeptEducationChannel';
import QuebecChannel from './pages/QuebecChannel';
import ChannelSolutions from './pages/ChannelSolutions';
import IspaiConnectDemo from './pages/IspaiConnectDemo';
import PlatformTechPage from './pages/PlatformTechPage';
import Channels from './pages/Channels';
import IspaiWaitlist from './pages/IspaiWaitlist';
import ModularConstructionPage from './pages/ModularConstructionPage';
import RequirementsGeneration from './pages/gsa-kbs/RequirementsGeneration';
import DesignTools from './pages/gsa-kbs/DesignTools';
import SubjectMatterExpertise from './pages/gsa-kbs/SubjectMatterExpertise';
import GovernmentStandards from './pages/gsa-kbs/GovernmentStandards';
import SiteSpecificConstraints from './pages/gsa-kbs/SiteSpecificConstraints';
import SpaceFurnitureLayout from './pages/gsa-kbs/SpaceFurnitureLayout';
import AnalysisTools from './pages/gsa-kbs/AnalysisTools';
import CostScheduleEstimation from './pages/gsa-kbs/CostScheduleEstimation';
import VisualizationRendering from './pages/gsa-kbs/VisualizationRendering';
import PostOccupancyMonitoring from './pages/gsa-kbs/PostOccupancyMonitoring';
import DemoCallForSolutionsForm from './pages/DemoCallForSolutionsForm';
import DemoCallForSolutionsFunctionalArea from './pages/DemoCallForSolutionsFunctionalArea';
import DemoCallForSolutionsBounty from './pages/DemoCallForSolutionsBounty';
import DemoCallForSolutionsBountyDetails from './pages/DemoCallForSolutionsBountyDetails';
import DemoCallForSolutionsQuebecForm from './pages/DemoCallForSolutionsQuebecForm';
import DemoCallForSolutionsQuebecFunctionalArea from './pages/DemoCallForSolutionsQuebecFunctionalArea';
import DemoCallForSolutionsQuebecBounty from './pages/DemoCallForSolutionsQuebecBounty';
import DemoCallForSolutionsQuebecBountyDetails from './pages/DemoCallForSolutionsQuebecBountyDetails';
import DemoCreatorRewards from './pages/DemoCreatorRewards';
import DemoCreatorRewardsQuebec from './pages/DemoCreatorRewardsQuebec';
import CallForDestructionForm from './pages/CallForDestructionForm';
import CallForDestructionFunctionalArea from './pages/CallForDestructionFunctionalArea';
import CallForDestructionBounty from './pages/CallForDestructionBounty';
import CallForDestructionBountyDetails from './pages/CallForDestructionBountyDetails';
import CallForDestructionCurator from './pages/CallForDestructionCurator';
import GsaCallForSolutions from './pages/GsaCallForSolutions';
import GsaCallForSolutionsBounty from './pages/GsaCallForSolutionsBounty';
import GsaCallForDestruction from './pages/GsaCallForDestruction';
import GsaCallForDestructionBounty from './pages/GsaCallForDestructionBounty';
import GsaChallenge1FunctionalArea from './pages/GsaChallenge1FunctionalArea';
import GsaChallenge1Bounty from './pages/GsaChallenge1Bounty';
import GsaChallenge1BountyDetails from './pages/GsaChallenge1BountyDetails';
import GsaChallenge1CreatorRewards from './pages/GsaChallenge1CreatorRewards';
import IspaiMarketplace from './pages/IspaiMarketplace';

function App() {
  return (
    <LanguageProvider>
      <TooltipProvider>
        <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/home" element={<Index />} />
      <Route path="/intro" element={<Intro />} />
      <Route path="/giblet" element={<Giblet />} />
      <Route path="/trey-profile" element={<TreyProfile />} />
      <Route path="/karen-profile" element={<KarenProfile />} />
      <Route path="/julia-derosi-profile" element={<JuliaDeRosiProfile />} />
      <Route path="/heather-edwards-profile" element={<HeatherEdwardsProfile />} />
      <Route path="/charles-hardy-profile" element={<CharlesHardyProfile />} />
      
      <Route path="/chris-profile" element={<ChrisProfile />} />
      <Route path="/corey-profile" element={<CoreyProfile />} />
      <Route path="/profile-jess" element={<JessProfile />} />
      <Route path="/mike-mosher-profile" element={<MikeMosherProfile />} />
      <Route path="/shaan-profile" element={<ShaanProfile />} />
      <Route path="/yannis-profile" element={<YannisProfile />} />
      <Route path="/miguel-profile" element={<MiguelProfile />} />
      <Route path="/morgan-profile" element={<MorganProfile />} />
      <Route path="/pete-profile" element={<PeteProfile />} />
      <Route path="/jim-profile" element={<JimProfile />} />
      <Route path="/steven-profile" element={<StevenProfile />} />
      <Route path="/eglantine-profile" element={<EglantineProfile />} />
      <Route path="/profile-eglantine" element={<EglantineProfile />} />
      <Route path="/ozlem-profile" element={<OzlemProfile />} />
      <Route path="/profile-ozlem" element={<OzlemProfile />} />
      <Route path="/solution-bounties/:userId" element={<SolutionBounties />} />
      <Route path="/know-your-gib" element={<KnowYourGib />} />
      <Route path="/curt-channel" element={<CurtChannel />} />
      <Route path="/gsa-channel" element={<GsaChannel />} />
      <Route path="/quebec-channel" element={<QuebecChannel />} />
      <Route path="/chevron-channel" element={<ChevronChannel />} />
      <Route path="/ispai-channel" element={<IspaiChannel />} />
      <Route path="/bechtel-channel" element={<BechtelChannel />} />
      <Route path="/dept-education-channel" element={<DeptEducationChannel />} />
      <Route path="/channels" element={<Channels />} />
      <Route path="/platform-tech" element={<PlatformTechPage />} />
      <Route path="/gsa-solutions" element={<ChannelSolutions />} />
      
      <Route path="/usa-solutions" element={<ChannelSolutions />} />
      <Route path="/chevron-solutions" element={<ChannelSolutions />} />
      <Route path="/ispai-connect-demo" element={<IspaiConnectDemo />} />
      <Route path="/giblet-connect-demo" element={<IspaiConnectDemo />} />
      <Route path="/ispai-waitlist" element={<IspaiWaitlist />} />
      <Route path="/modular-construction" element={<ModularConstructionPage />} />
      <Route path="/gsa-kb/requirements-generation" element={<RequirementsGeneration />} />
      <Route path="/gsa-kb/design-tools" element={<DesignTools />} />
      <Route path="/gsa-kb/subject-matter-expertise" element={<SubjectMatterExpertise />} />
      <Route path="/gsa-kb/government-standards" element={<GovernmentStandards />} />
      <Route path="/gsa-kb/site-specific-constraints" element={<SiteSpecificConstraints />} />
      <Route path="/gsa-kb/space-furniture-layout" element={<SpaceFurnitureLayout />} />
      <Route path="/gsa-kb/analysis-tools" element={<AnalysisTools />} />
      <Route path="/gsa-kb/cost-schedule-estimation" element={<CostScheduleEstimation />} />
      <Route path="/gsa-kb/visualization-rendering" element={<VisualizationRendering />} />
      <Route path="/gsa-kb/post-occupancy-monitoring" element={<PostOccupancyMonitoring />} />
      <Route path="/demo-call-for-solutions" element={<DemoCallForSolutionsForm />} />
      <Route path="/demo-call-for-solutions/functional-area" element={<DemoCallForSolutionsFunctionalArea />} />
      <Route path="/demo-call-for-solutions/bounty" element={<DemoCallForSolutionsBounty />} />
      <Route path="/demo-call-for-solutions/bounty-details" element={<DemoCallForSolutionsBountyDetails />} />
      <Route path="/demo-call-for-solutions-quebec" element={<DemoCallForSolutionsQuebecForm />} />
      <Route path="/demo-call-for-solutions-quebec/functional-area" element={<DemoCallForSolutionsQuebecFunctionalArea />} />
      <Route path="/demo-call-for-solutions-quebec/bounty" element={<DemoCallForSolutionsQuebecBounty />} />
      <Route path="/demo-call-for-solutions-quebec/bounty-details" element={<DemoCallForSolutionsQuebecBountyDetails />} />
      <Route path="/demo-creator-rewards" element={<DemoCreatorRewards />} />
      <Route path="/demo-creator-rewards-quebec" element={<DemoCreatorRewardsQuebec />} />
      <Route path="/call-for-destruction-bounty" element={<CallForDestructionForm />} />
      <Route path="/call-for-destruction/functional-area" element={<CallForDestructionFunctionalArea />} />
      <Route path="/call-for-destruction/bounty" element={<CallForDestructionBounty />} />
      <Route path="/call-for-destruction/bounty-details" element={<CallForDestructionBountyDetails />} />
      <Route path="/call-for-destruction/curator" element={<CallForDestructionCurator />} />
      <Route path="/gsa-call-for-solutions" element={<GsaCallForSolutions />} />
      <Route path="/gsa-call-for-solutions/bounty" element={<GsaCallForSolutionsBounty />} />
      <Route path="/gsa-call-for-destruction" element={<GsaCallForDestruction />} />
      <Route path="/gsa-call-for-destruction/bounty" element={<GsaCallForDestructionBounty />} />
      <Route path="/gsa-challenge-1/functional-area" element={<GsaChallenge1FunctionalArea />} />
      <Route path="/gsa-challenge-1/bounty" element={<GsaChallenge1Bounty />} />
      <Route path="/gsa-challenge-1/bounty-details" element={<GsaChallenge1BountyDetails />} />
      <Route path="/gsa-challenge-1/creator-rewards" element={<GsaChallenge1CreatorRewards />} />
        <Route path="/ispai-marketplace" element={<IspaiMarketplace />} />
        <Route path="/ispai-solutions" element={<IspaiMarketplace />} />
        </Routes>
      </TooltipProvider>
    </LanguageProvider>
  );
}

export default App;
